import resolveDefaultProps from "utils/resolveDefaultProps";
import React from 'react'
import PropTypes from 'prop-types'

const TextEllipsis = props => {
  props = resolveDefaultProps(props, TextEllipsisDefaults);


	const { text, maxTextCount } = props

	return (
		<>
			{(text && text.length) > maxTextCount ? text.substring(0, (maxTextCount - 3)) + '...' : text}
		</>
	)
}

TextEllipsis.propTypes = {
	text: PropTypes.string,
}

const TextEllipsisDefaults = {
	text: '',
	maxTextCount: 0
}

export default TextEllipsis